export default "__VITE_ASSET__bduE77kj__"